import React, { useEffect, useState } from 'react';
import { Card, Timeline, Typography, Tag, Button, Modal, Spin } from 'antd';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { ClockCircleOutlined, EyeOutlined } from '@ant-design/icons';
import moment from 'moment';
import LayoutWithSider from '../../core/components/layout/layout-with-sider/LayoutWithSider';

const { Title, Text } = Typography;

export default function ChangelogHistory() {
    const { t, i18n } = useTranslation();
    const history = useHistory();
    const [loading, setLoading] = useState(true);
    const [releases, setReleases] = useState([]);
    // Normalize language code locally
    const currentLang = (i18n.language || 'tr').substring(0, 2);

    useEffect(() => {
        fetch('/changelogs/versions.json')
            .then(res => res.json())
            .then(data => {
                if (data && data.versions) {
                    const sorted = data.versions.sort((a, b) => {
                        return new Date(b.releaseDate) - new Date(a.releaseDate);
                    });
                    setReleases(sorted);
                }
            })
            .catch(err => console.error("Failed to load versions", err))
            .finally(() => setLoading(false));
    }, []);

    const handleIframeLoad = (e) => {
        const iframe = e.target;
        if (iframe && iframe.contentWindow) {
            // Add a small buffer to prevent scrollbar flickering
            iframe.style.height = (iframe.contentWindow.document.body.scrollHeight + 20) + 'px';
        }
    };

    return (
        <LayoutWithSider>
            <div style={{ padding: '24px' }}>
                <Card title={<Title level={3} style={{ margin: 0 }}>{t('Changelog History')}</Title>}>
                    {loading ? (
                        <div style={{ textAlign: 'center', padding: 50 }}>
                            <Spin size="large" />
                        </div>
                    ) : (
                        <div>
                            {releases.map(release => (
                                <div key={release.version} style={{ marginBottom: 40, borderBottom: '1px solid #f0f0f0', paddingBottom: 20 }}>
                                    <div style={{ marginBottom: 10 }}>
                                        <Title level={4} style={{ margin: 0 }}>v{release.version}</Title>
                                        <Text type="secondary">{moment(release.releaseDate).format('LL')}</Text>
                                    </div>
                                    <iframe
                                        src={`/changelogs/${release.version}/index.html?lang=${currentLang}`}
                                        style={{ width: '100%', border: 'none', overflow: 'hidden' }}
                                        title={`Changelog v${release.version}`}
                                        onLoad={handleIframeLoad}
                                        scrolling="no"
                                    />
                                </div>
                            ))}
                        </div>
                    )}
                </Card>
            </div>
        </LayoutWithSider>
    );
}
